import { Box, Button, Card, CardContent, CardMedia, Chip, IconButton, Tooltip, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import Grid from '@mui/material/Grid2'
import React, { useEffect, useState } from 'react'
import BiodiversityMap from '../../../../resources/images/biodevmap.png'
import { SiteCard, SiteDetailCard } from '../../../common/detailComponent'
import SiteArea from '../../../../resources/images/sitearea.svg'
import SiteCamera from '../../../../resources/images/sitecamera.svg'
import SiteAudio from '../../../../resources/images/siteaudio.svg'
import SiteSpecies from '../../../../resources/images/sitespecies.svg'
import SiteImage from '../../../../resources/images/siteimg.svg'
import SiteFile from '../../../../resources/images/sitefile.svg'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { ChartComponent } from '../../../common/chartComponent'
import { ProjectCardComponent, ProjectDashboardComponent } from '../../../common/cardComponent'
import { getProjectByName } from '../../../../utils/mergeData';
import ProjectMapbox from '../ProjectGeoMap'
import areaCovered from '../../../../resources/images/site-area.png';
import cameraInstalled from '../../../../resources/images/site-camera.png'
import audioDevices from '../../../../resources/images/site-audio.png'
import Mapbox from '../ProjectMap'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import ProjectOverview from '../../../../resources/images/Project_overview.png'
import Monitoring from '../../../../resources/images/Monitoring.png'
import HumanImpact from '../../../../resources/images/Human_impact.png'
import Biohealth from '../../../../resources/images/Biodiversity_heath.png'
import { getIntactnessRangeCategory, convertToNumber, getSpeciesAbundanceRangeCategory, getPotentialRangeCategory, getHumanIntrusionRangeCategory } from '../../../../constants/index';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import DMapCA from '../DMap/DMapCA'
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import DMapDashBoard from '../DMap/DMapDashboard'

const BiodiversityDashboardSiteInfo = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const siteDetails = location.state || {};
    const selectedProjectStr = localStorage.getItem('selectedProject');
    const selectedProject = selectedProjectStr ? JSON.parse(selectedProjectStr) : null;
    const currentProjectBio = getProjectByName(selectedProject?.project_name);

    const filterSpeciesData = currentProjectBio?.species_distribution

    const speciesData = [
        {
            name: 'Critically Endangered',
            value1: parseInt(filterSpeciesData ? filterSpeciesData[0].critically_endangered[0].total : ''),
            species: filterSpeciesData ? filterSpeciesData[0].critically_endangered[0].species_list.join(', ') : ''
        },
        {
            name: 'Endangered',
            value1: parseInt(filterSpeciesData ? filterSpeciesData[0].endangered[0].total : ''),
            species: filterSpeciesData ? filterSpeciesData[0].endangered[0].species_list.join(', ') : ''
        },
        {
            name: 'Vulnerable',
            value1: parseInt(filterSpeciesData ? filterSpeciesData[0].vulnerable[0]?.total : ''),
            species: filterSpeciesData ? filterSpeciesData[0].vulnerable[0].species_list.join(', ') : ''
        },
        {
            name: 'Near Threatened',
            value1: parseInt(filterSpeciesData ? filterSpeciesData[0].near_threatened[0].total : ''),
            species: filterSpeciesData ? filterSpeciesData[0].near_threatened[0].species_list.join(', ') : ''
        },
        {
            name: 'Least Concerned',
            value1: parseInt(filterSpeciesData ? filterSpeciesData[0].least_concerned[0].total : ''),
            species: filterSpeciesData ? filterSpeciesData[0].least_concerned[0].species_list.join(', ') : ''
        },
    ];
    const handleSelectSite = (site: any) => {
        localStorage.setItem('SelectedDropDownSite', JSON.stringify(site))
    };
    const chartData = speciesData.map(item => ({
        name: item.name,
        y: item.value1,
        description: item.species.split(', ').map((species: any) => `<br/>- ${species}`).join(''),
    }));
    const options = {
        chart: {
            type: 'pie',
        },
        title: {
            text: null,
        },
        credits: {
            enabled: false,
        },
        tooltip: {
            pointFormat: `
                Total No.: <b>{point.y}</b><br/>
                Species: <b>{point.description}</b><br/>
                Percentage: <b>{point.percentage:.1f}%</b>
            `,
        },
        legend: {
            enabled: true, // Ensure the legend is enabled
            layout: 'horizontal', // Arrange legends vertically
            align: 'center', // Align legends to the right
            verticalAlign: 'bottom', // Vertically align legends to the middle
        },
        plotOptions: {
            pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                dataLabels: {
                    distance: -30,
                    enabled: true,
                    format: `<b>{point.y}</b><br/>`,
                    style: {
                        color: '#ffffff',
                        fontSize: '14px',
                        fontWeight: 'bold',
                    },
                },
                innerSize: '50%', // For donut effect
            },
        },
        series: [
            {
                name: 'Species',
                colorByPoint: true,
                showInLegend: true, // Enable legends for this series
                data: chartData, // Ensure this contains valid data
            },
        ],
    };


    return (
        <Box sx={{ mt: 5 }}>
            <Box className='bio-map' sx={{ mb: 3 }}>
                {/* <DMapCA /> */}
                <DMapDashBoard />
            </Box>

            <Box sx={{
                border: '1px solid #ccc',
                // padding: '10px',
                backgroundColor: "#fff",
                marginTop: "5px",
                borderRadius: "8px",
                boxShadow: "0px 0px 5px 0px rgba(0, 0, 0, 0.1019607843) !important",
            }}>
                <Typography sx={{ fontWeight: 600, fontSize: "22px", color: "#151E15", m: 2 }}>
                    {currentProjectBio?.project_name}
                </Typography>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', borderTop: '1px solid #D9D9D9' }} gap={2} />
                <Grid container spacing={4}>
                    <Grid size={{ xs: 12, md: 3 }} px={1}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <Box
                                component="img"
                                src={ProjectOverview}
                                alt="Project Overview"
                                sx={{
                                    width: "45px",
                                    height: "35px",
                                    objectFit: "contain", // Ensures the image fits within its dimensions
                                }}
                            />
                            <Typography sx={{ fontWeight: 600, fontSize: "18px", color: "#151E15", py: 2 }}>
                                {'Project Details'}
                            </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', borderTop: '1px solid #D9D9D9' }} gap={2} />
                        <Box sx={{ display: 'flex', flexDirection: 'column', padding: "16px", marginLeft: "40px" }} gap={2}>
                            <Box>
                                <Typography sx={{ color: "#666666", fontWeight: 600, fontSize: '16px' }}>
                                    {'Project Id'}
                                </Typography>
                                <Typography sx={{ color: "#000", fontWeight: 500, fontSize: '20px' }}>
                                    {currentProjectBio?.project_id}
                                </Typography>
                            </Box>
                            <Box>
                                <Typography sx={{ color: "#666666", fontWeight: 600, fontSize: '16px' }}>
                                    {'Total Area'}
                                </Typography>
                                <Typography sx={{ color: "#000", fontWeight: 500, fontSize: '20px' }}>
                                    {currentProjectBio?.total_area}
                                </Typography>
                            </Box>
                            <Box>
                                <Typography sx={{ color: "#666666", fontWeight: 600, fontSize: '16px' }}>
                                    {'Total Sites'}
                                </Typography>
                                <Typography sx={{ color: "#000", fontWeight: 500, fontSize: '20px' }}>
                                    {currentProjectBio?.number_of_sites}
                                </Typography>
                            </Box>
                            <Box>
                                <Typography sx={{ color: "#666666", fontWeight: 600, fontSize: '16px' }}>
                                    {'Total Species Identified'}
                                </Typography>
                                <Typography sx={{ color: "#000", fontWeight: 500, fontSize: '20px' }}>
                                    {currentProjectBio?.total_species_identified ?? currentProjectBio?.insitu_species_count ?? 15}
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>

                    <Grid size={{ xs: 12, md: 3 }} px={1}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <Box
                                component="img"
                                src={Monitoring}
                                alt="Project Overview"
                                sx={{
                                    width: "45px",
                                    height: "35px",
                                    objectFit: "contain", // Ensures the image fits within its dimensions
                                }}
                            />
                            <Typography sx={{ fontWeight: 600, fontSize: "18px", color: "#151E15", py: 2 }}>
                                {'Monitoring & Data Collection'}
                            </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', borderTop: '1px solid #D9D9D9' }} gap={2} />
                        <Box sx={{ display: 'flex', flexDirection: 'column', padding: "16px", marginLeft: "40px" }} gap={2}>
                            <Box>
                                <Typography sx={{ color: "#666666", fontWeight: 600, fontSize: '16px' }}>
                                    {'Cameras Devices Installed'}
                                </Typography>
                                <Typography sx={{ color: "#000", fontWeight: 500, fontSize: '20px' }}>
                                    {currentProjectBio?.cameras_installed ?? currentProjectBio?.camera_installed}
                                </Typography>
                            </Box>

                            <Box>
                                <Typography sx={{ color: "#666666", fontWeight: 600, fontSize: '16px' }}>
                                    {'Audio Devices Installed'}
                                </Typography>
                                <Typography sx={{ color: "#000", fontWeight: 500, fontSize: '20px' }}>
                                    {currentProjectBio?.audio_devices_installed ?? currentProjectBio?.audio_devices}
                                </Typography>
                            </Box>

                            <Box>
                                <Typography sx={{ color: "#666666", fontWeight: 600, fontSize: '16px' }}>
                                    {'Total Images/Videos'}
                                </Typography>
                                <Typography sx={{ color: "#000", fontWeight: 500, fontSize: '20px' }}>
                                    {currentProjectBio?.total_images_videos ?? currentProjectBio?.total_species_recorded ?? 450}
                                </Typography>
                            </Box>

                            <Box>
                                <Typography sx={{ color: "#666666", fontWeight: 600, fontSize: '16px' }}>
                                    {'Audio Files'}
                                </Typography>
                                <Typography sx={{ color: "#000", fontWeight: 500, fontSize: '20px' }}>
                                    {currentProjectBio?.total_audiofiles ?? 120}
                                </Typography>
                            </Box>
                        </Box>

                    </Grid>

                    <Grid size={{ xs: 12, md: 3 }} px={1}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <Box
                                component="img"
                                src={Biohealth}
                                alt="Project Overview"
                                sx={{
                                    width: "45px",
                                    height: "35px",
                                    objectFit: "contain", // Ensures the image fits within its dimensions
                                }}
                            />
                            <Typography sx={{ fontWeight: 600, fontSize: "18px", color: "#151E15", py: 2 }}>
                                {'Biodiversity Health'}
                            </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', borderTop: '1px solid #D9D9D9' }} gap={2} />
                        <Box sx={{ display: 'flex', flexDirection: 'column', padding: "16px", marginLeft: "10px" }} gap={2}>
                            <Box>
                                <Box display="flex" alignItems="center" gap={1}>
                                    <Typography sx={{ color: "#666666", fontWeight: 600, fontSize: '16px' }}>
                                        {'Biodiversity Score Index'}
                                    </Typography>
                                    <Tooltip
                                        title="An overall indicator that combines multiple biodiversity metrics 
to represent the health and diversity of the ecosystem.
 • Good: 0.75 - 1.00 (Healthy and diverse ecosystem)
• Medium: 0.50 - 0.74 (Moderate health, some loss of diversity)
• Bad: 0.00 - 0.49 (Poor health, low biodiversity)"
                                        arrow
                                        placement="top"
                                    >
                                        <IconButton size="small" sx={{ padding: 0, color: "#666666" }}>
                                            <InfoOutlinedIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                                <Box>
                                    <Typography sx={{ color: getIntactnessRangeCategory(convertToNumber(currentProjectBio?.biodiversity_score ?? 0)).color, fontWeight: 500, fontSize: '20px' }}>
                                        {currentProjectBio?.biodiversity_score}
                                    </Typography>
                                </Box>
                            </Box>

                            <Box>
                                <Box display="flex" alignItems="center" gap={1}>
                                    <Typography sx={{ color: "#666666", fontWeight: 600, fontSize: '16px' }}>
                                        {'Biodiversity Intactness Index'}
                                    </Typography>
                                    <Tooltip
                                        title="A measure of how much of the original biodiversity 
remains intact in the ecosystem, relative to undisturbed conditions.
• Good: 0.75 - 1.00 (High intactness, minimal disturbance)
• Medium: 0.50 - 0.74 (Moderate disturbance, some biodiversity loss)
• Bad: 0.00 - 0.49 (Severe disturbance, significant biodiversity loss)"
                                        arrow
                                        placement="top"
                                    >
                                        <IconButton size="small" sx={{ padding: 0, color: "#666666" }}>
                                            <InfoOutlinedIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                                <Box>
                                    <Typography sx={{
                                        color: getIntactnessRangeCategory(convertToNumber(currentProjectBio?.biodiversity_intactness
                                            ?? currentProjectBio?.biodiversity_intactness_index ?? 0)).color, fontWeight: 500, fontSize: '20px'
                                    }}>
                                        {currentProjectBio?.biodiversity_intactness ?? currentProjectBio?.biodiversity_intactness_index}

                                    </Typography>
                                </Box>
                            </Box>


                            <Box>
                                <Box display="flex" alignItems="center" gap={1}>
                                    <Typography sx={{ color: "#666666", fontWeight: 600, fontSize: '16px' }}>
                                        {'Mean Species Abundance'}
                                    </Typography>
                                    <Tooltip
                                        title="The average abundance of native species in the area 
compared to their abundance in an undisturbed ecosystem.
• Good: 0.70 - 1.00 (Abundance close to natural levels)
• Medium: 0.40 - 0.69 (Reduced abundance, moderate impact)
• Bad: 0.00 - 0.39 (Low abundance, high impact)"
                                        arrow
                                        placement="top"
                                    >
                                        <IconButton size="small" sx={{ padding: 0, color: "#666666" }}>
                                            <InfoOutlinedIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                                <Box>

                                    <Typography sx={{
                                        color: getSpeciesAbundanceRangeCategory(convertToNumber(currentProjectBio?.mean_species_abundance
                                            ?? currentProjectBio?.msa ?? 0)).color, fontWeight: 500, fontSize: '20px'
                                    }}>
                                        {currentProjectBio?.mean_species_abundance ?? currentProjectBio?.msa}
                                    </Typography>
                                </Box>
                            </Box>

                            <Box>
                                <Box display="flex" alignItems="center" gap={1}>
                                    <Typography sx={{ color: "#666666", fontWeight: 600, fontSize: '16px' }}>
                                        {'Potential Disappearance Fraction'}
                                        <Tooltip
                                            title="The estimated proportion of species at risk of 
disappearing due to environmental degradation or human impact.
• Good: 0.00 - 0.20 (Low risk of species disappearance)
• Medium: 0.21 - 0.40 (Moderate risk of species disappearance)
• Bad: 0.41 - 1.00 (High risk of species disappearance)"
                                            arrow
                                            placement="top"
                                            sx={{ marginLeft: "8px" }}
                                        >
                                            <IconButton size="small" sx={{ padding: 0, color: "#666666" }}>
                                                <InfoOutlinedIcon fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                    </Typography>
                                </Box>
                                <Box>

                                    <Typography sx={{
                                        color: getPotentialRangeCategory(convertToNumber(currentProjectBio?.potential_disappearance_fraction
                                            ?? 0)).color, fontWeight: 500, fontSize: '20px'
                                    }}>
                                        {currentProjectBio?.potential_disappearance_fraction}
                                    </Typography>
                                </Box>
                            </Box>

                        </Box>
                    </Grid>

                    <Grid size={{ xs: 12, md: 3 }} px={1}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <Box
                                component="img"
                                src={HumanImpact}
                                alt="Project Overview"
                                sx={{
                                    width: "45px",
                                    height: "35px",
                                    objectFit: "contain", // Ensures the image fits within its dimensions
                                }}
                            />
                            <Typography sx={{ fontWeight: 600, fontSize: "18px", color: "#151E15", py: 2 }}>
                                {'Human Impact'}
                            </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', borderTop: '1px solid #D9D9D9' }} gap={2} />
                        <Box sx={{ display: 'flex', flexDirection: 'column', padding: "16px", marginLeft: "40px" }} gap={2}>
                            <Box>
                                <Box display="flex" alignItems="center" gap={1}>
                                    <Typography sx={{ color: "#666666", fontWeight: 600, fontSize: '16px' }}>
                                        {'Human Intrusion Index'}
                                    </Typography>
                                    <Tooltip
                                        title="A measure of the extent and intensity of human activities 
affecting the ecosystem. 
• Good: 0.00 - 0.20 (Minimal human activity and low impact)
• Medium: 0.21 - 0.50 (Moderate human activity and impact)
• Bad: 0.51 - 1.00 (High human activity and severe impact)"
                                        arrow
                                        placement="top"
                                    >
                                        <IconButton size="small" sx={{ padding: 0, color: "#666666" }}>
                                            <InfoOutlinedIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                                <Box>
                                    <Typography sx={{
                                        color: getHumanIntrusionRangeCategory(convertToNumber(currentProjectBio?.human_intrusion_index
                                            ?? currentProjectBio?.human_intrusion ?? 0)).color, fontWeight: 500, fontSize: '20px'
                                    }}>
                                        {currentProjectBio?.human_intrusion_index ?? currentProjectBio?.human_intrusion}
                                    </Typography>
                                </Box>
                            </Box>

                        </Box>
                    </Grid>

                </Grid>
            </Box>

            <Grid size={{ lg: 4, md: 6 }} sx={{ marginTop: '10px' }}>
                <Card sx={{
                    boxShadow: "0px 0px 5px 0px rgba(0, 0, 0, 0.1019607843) !important",
                    borderRadius: '8px',
                    backgroundColor: '#fff',
                }}>
                    <Typography
                        component="div"
                        sx={{ textAlign: "left", fontSize: "16px", fontWeight: 600, color: '#151E15', p: "16px" }}
                    >{'Species Distribution by Threat Level'}
                    </Typography>
                    <Box className='divider' sx={{ p: 2 }} />
                    <HighchartsReact highcharts={Highcharts} options={options} />
                </Card>
            </Grid>
            <Box>
                <Typography sx={{ fontSize: "24px", fontWeight: 600, color: "#151E15", margin: "5px" }}>{'Project Sites'}</Typography>
                <Box sx={{
                    display: 'flex',
                    gap: 2,
                    p: 1,
                }}>
                    <Swiper navigation={true} modules={[Navigation]} slidesPerView={3} spaceBetween={30}
                        breakpoints={{
                            320: {
                                slidesPerView: 1,
                                spaceBetween: 10,
                            },
                            768: {
                                slidesPerView: 2,
                                spaceBetween: 20,
                            },
                            1024: {
                                slidesPerView: 3,
                                spaceBetween: 30,
                            },
                        }} style={{ width: '100%' }} >
                        {currentProjectBio && (currentProjectBio as any)?.sites.map((site: any, index: any) => {
                            return (
                                <SwiperSlide>
                                    <Link to={`/biodiversity-analysis-detail`} style={{ textDecoration: 'none' }} key={index} onClick={() => handleSelectSite(site)}>
                                        <Card sx={{ display: 'flex', backgroundColor: "#151E15", borderRadius: 2 }}>
                                            <Box sx={{ flex: 1 }}>
                                                <CardMedia
                                                    component="img"
                                                    sx={{ height: '100%', objectFit: 'cover' }}
                                                    image={BiodiversityMap}
                                                    alt="Site image"
                                                />
                                            </Box>

                                            <Box sx={{
                                                display: 'flex', flexDirection: 'column', padding: 2, gap: 1.5,
                                                flex: 1
                                            }}>
                                                <Typography sx={{ fontWeight: 600, fontSize: "18px", color: "#fff" }}>
                                                    {site.site_name}
                                                </Typography>
                                                <Typography sx={{ fontWeight: 600, fontSize: "15px", color: "#fff" }}>
                                                    {site.type}
                                                </Typography>
                                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                                                    {/* Area Covered */}
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, color: '#fff' }}>
                                                        <img src={areaCovered} alt="area covered" style={{ width: 20, height: 20 }} />
                                                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                                            <Typography component="div" sx={{ fontSize: "12px", fontWeight: 500 }}>
                                                                {'Area Covered'}
                                                            </Typography>
                                                            <Typography component="div" sx={{ fontSize: "18px", fontWeight: 600 }}>
                                                                {site.area}
                                                            </Typography>
                                                        </Box>
                                                    </Box>

                                                    {/* Cameras Installed */}
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, color: '#fff' }}>
                                                        <img src={cameraInstalled} alt="camera installed" style={{ width: 20, height: 20 }} />
                                                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                                            <Typography component="div" sx={{ fontSize: "12px", fontWeight: 500 }}>
                                                                {'Cameras Installed'}
                                                            </Typography>
                                                            <Typography component="div" sx={{ fontSize: "18px", fontWeight: 600 }}>
                                                                {site.camera_installed}
                                                            </Typography>
                                                        </Box>
                                                    </Box>

                                                    {/* Audio Devices */}
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, color: '#fff' }}>
                                                        <img src={audioDevices} alt="audio devices" style={{ width: 20, height: 20 }} />
                                                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                                            <Typography component="div" sx={{ fontSize: "12px", fontWeight: 500 }}>
                                                                {'Audio Devices'}
                                                            </Typography>
                                                            <Typography component="div" sx={{ fontSize: "18px", fontWeight: 600 }}>
                                                                {site.audio_devices}
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                </Box>

                                            </Box>
                                        </Card>
                                    </Link>
                                </SwiperSlide>
                            )
                        })}
                    </Swiper>
                </Box>
            </Box>
        </Box>
    )
}

export default BiodiversityDashboardSiteInfo